// @flow
import * as React from "react";
import idx from "idx";
import { withRouter, type Match, type Location } from "react-router-dom";
import styled from "styled-components";
import Gettext from "../../common/Gettext";
import { StyledPopup as Popup } from "./Popup";
import { FlatButton } from "../../Buttons";
import Link from "../Link";
import * as S from "./styles";
import Spinner from "../../Spinners/SimpleSpinner";
import dataLayer from "../../common/dataLayer";
import * as custom from "../../common/customConsole";

import Tournament from "../Api";
import TournamentId from "../TournamentId";
import { gaReducer } from "../../GA";

const ButtonsWrapper = styled.div`
  width: 100%;
  margin: 15px 0;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  align-content: space-between;

  @media (max-width: 959px) {
    max-width: calc(169px * 2 + 15px);
  }

  @media (max-width: 479px) {
    justify-content: center;
    align-content: center;
  }
`;

const ButtonContainer = styled.div`
  display: table;
  min-width: 169px;

  @media (max-width: 479px) {
    :not(:last-of-type) {
      margin-bottom: 15px;
    }
  }
`;

const Name = styled.div`
  margin-bottom: 20px;
  color: ${({ theme }) => theme.accent};
`;

type Props = {
  onDismiss: (props?: any) => void,
  onDismissAll: () => void,
  popupCallback?: (status: string) => void,
  id?: number,
  tournamentId: ?number,
  title?: string,
  dontRedirect?: boolean,
  match: Match,
  location: Location,
  style?: string,
  in: boolean,
  api: any,
  changeTournamentId: (id: number) => void,
  fromTournamentsList?: boolean
};

type State = {
  fetching: boolean
};

class LeavePopup extends React.Component<Props, State> {
  state = {
    fetching: false
  };

  leaveTournament = async (id: number) => {
    try {
      const { api, onDismiss, popupCallback } = this.props;

      this.setState({
        fetching: true
      });

      const leave = await api.fetchEntity(
        `/api/tournaments/leave?tournament_id=${id}`
      );

      if (leave.status === "Resolved") {
        dataLayer({
          event: "event-to-ga",
          eventCategory: "Tournaments",
          eventAction: "tournament-leave",
          eventLabel: `Пользователь ушел из турнира${id}`
        });
        this.props.fromTournamentsList &&
          (await api.fetchEntity(`/api/tournaments${this.props.apiParams}`));
        api.fetchEntity(
          "/api/tournaments/list?status=1&participation_status=1"
        );
        api.fetchEntity("/api/bell-tolls-items");
        api.fetchEntity(`/api/tournaments/stats`);
        api.fetchEntity(`/api/tournaments/info?id=${id}`);

        this.setState({
          fetching: false
        });
        onDismiss({
          all: true,
          callback: popupCallback ? () => popupCallback("success") : null
        });
      }
    } catch (error) {
      this.setState({
        fetching: false
      });
      custom.error(`Leaving tournament went wrong! ${error}`);
    }
  };

  componentDidMount() {
    gaReducer("SHOW_TOURNAMENT_LEAVE_POPUP");
    const path = (this.props.match, match => match.path);
    const id = idx(this.props.match, match => match.params.id);

    if (id != null && path != null && path === "/trade/tournaments/leave/:id") {
      this.props.changeTournamentId(id);
      return;
    }
  }

  render() {
    const { in: inProp, onDismiss, style, api, ...props } = this.props;

    const id = props.id != null ? props.id : this.props.tournamentId;
    let tournament = props;

    if (id == null) {
      return null;
    }

    if (!props.title) {
      const info = idx(
        api.readEntity(`/api/tournaments/info?id=${id}`),
        info => info.value
      );

      if (info == null) {
        return (
          <Popup
            in={inProp}
            style={style}
            fades={!!style ? true : false}
            onDismiss={onDismiss}
          >
            <S.Wrapper>
              <Spinner accent />
            </S.Wrapper>
          </Popup>
        );
      }

      tournament = info;
    }

    return (
      <Popup
        in={inProp}
        style={style}
        fades={!!style ? false : true}
        onDismiss={onDismiss}
      >
        <S.Wrapper>
          <S.MobileWrapper>
            <S.Title>
              <Name>{tournament.title}</Name>
              <Gettext>Are you sure you want to leave the tournament?</Gettext>
            </S.Title>
            <ButtonsWrapper>
              <ButtonContainer>
                <FlatButton
                  disabled={this.state.fetching}
                  onClick={() => {
                    gaReducer("CLICKBTN_LEAVE_TOURNAMENT");
                    return this.leaveTournament(id);
                  }}
                >
                  <span>
                    {this.state.fetching && <Spinner />} <Gettext>Yes</Gettext>
                  </span>
                </FlatButton>
              </ButtonContainer>
              <ButtonContainer>
                <FlatButton
                  disabled={this.state.fetching}
                  type="trade"
                  onClick={onDismiss}
                >
                  <Gettext>No</Gettext>
                </FlatButton>
              </ButtonContainer>
            </ButtonsWrapper>
            {!this.props.dontRedirect && (
              <Link to="/tournaments">
                <Gettext>All tournaments</Gettext>
              </Link>
            )}
          </S.MobileWrapper>
        </S.Wrapper>
      </Popup>
    );
  }
}

export default withRouter(props => (
  <Tournament.Consumer>
    {api => (
      <TournamentId.Consumer>
        {contextId => (
          <LeavePopup
            {...props}
            {...contextId}
            api={api}
            key={contextId.tournamentId}
          />
        )}
      </TournamentId.Consumer>
    )}
  </Tournament.Consumer>
));



// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/Leave.js